import 'babel-polyfill';
import Vue from 'vue';
//Put this into your main.js file anywhere AFTER loading Vue
import VueMeta from 'vue-meta';
import App from './App.vue';
import AnalyticsTracking from '../../shared/plugins/analytics-tracking';
import StringFilters from '../../shared/filters/string-filter';

Vue.use(VueMeta)
Vue.use(StringFilters);
Vue.use(AnalyticsTracking);
Vue.config.productionTip = false;
Vue.mixin({
    methods: {
        openModal: function(modal) {
            const backdrop = document.createElement('div');
            backdrop.classList.add('modal-backdrop', 'fade');
            document.body.classList.add('modal-open');
            document.body.appendChild(backdrop);
            document.querySelector(modal).style.display = 'block';
            document.querySelector(modal).setAttribute('aria-hidden', 'false', 'show');
            setTimeout(() => {
                document.querySelector(modal).classList.add('show');
                backdrop.classList.add('show');
            })
        }
    }
})
const appElement = document.getElementById('app');
const pageVariationData = appElement.getAttribute('data-page-variation');
const parsedModel = JSON.parse(pageVariationData);
new Vue({
    el: '#app',
    render: h => h(App, {
        props: {
            pageVariation: parsedModel
        }
    })
});
